import { render, staticRenderFns } from "./fireFightingItem.vue?vue&type=template&id=37a97eaf"
import script from "./fireFightingItem.vue?vue&type=script&lang=js"
export * from "./fireFightingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a97eaf')) {
      api.createRecord('37a97eaf', component.options)
    } else {
      api.reload('37a97eaf', component.options)
    }
    module.hot.accept("./fireFightingItem.vue?vue&type=template&id=37a97eaf", function () {
      api.rerender('37a97eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/base/fireFightingItem.vue"
export default component.exports